import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    api
      .post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } })
      .then((res) => {
        setUser(res.data);
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true });
      })
      .catch((err) => {
        setUser(false);
        toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Sign-in failed");
        window.history.replaceState(null, "", "/login");
        navigate("/login", { replace: true });
      });
  }, [navigate, setUser]);

  return (
    <div className="h-screen flex flex-col items-center justify-center bg-zinc-950 text-zinc-400 gap-3">
      <Loader2 className="h-6 w-6 animate-spin text-indigo-400" />
      <p className="text-sm">Signing you in…</p>
    </div>
  );
}
